import classes from '../DashboardItem.module.css'

import DashboardViewAll from '../../DashboardViewAll';
// import InfoButton from '../../InfoButton';
import TasksList from './TasksList';
import { useGetTasksListDashboard } from '../../../../lib/hooks';
import WidgetSummary from '../WidgetSummary';

export default function TasksWidget() {
    const PER_PAGE = 5
    useGetTasksListDashboard(PER_PAGE)


    return <div className={`${classes.item_inner}`}>
        <div className={classes.item_header}>
            <div>
                <div className={classes.item_title}>
                    Tasks
                    {/* <InfoButton info={'different info to know that this is different'}/> */}
                </div>

                <WidgetSummary perPage={PER_PAGE} widgetType={'tasks'}/>
            </div>
            <DashboardViewAll urlPage={'/tasks'}/>
        </div>
        <div className={classes.item_body}>
            <div className={classes.container}>
                <table className='table-border-radius-8'>
                    <thead>
                        <tr>
                            <th></th>
                            <th>NG #</th>
                            <th>Patient Name</th>
                            <th>Date added</th>
                            <th>Added by</th>
                            <th>Note type</th>
                            <th>Notes</th>
                            <th>Priority</th>
                            <th>Assigned to</th>
                            <th>Action required</th>
                            <th>Due date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <TasksList />
                    </tbody>
                </table>
            </div>
        </div>
    </div>
}